import { render, staticRenderFns } from "./profileDetails.vue?vue&type=template&id=6ee353c0&scoped=true"
import script from "./profileDetails.vue?vue&type=script&lang=js"
export * from "./profileDetails.vue?vue&type=script&lang=js"
import style0 from "./profileDetails.vue?vue&type=style&index=0&id=6ee353c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee353c0",
  null
  
)

export default component.exports